import { useEffect, useState } from "react";

export const SUPPORT_MODE_STORAGE_KEY = "loadAgent.supportMode.v1";

function readSupportMode(): boolean {
  try {
    return window.localStorage.getItem(SUPPORT_MODE_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

function writeSupportMode(enabled: boolean): void {
  try {
    if (enabled) window.localStorage.setItem(SUPPORT_MODE_STORAGE_KEY, "1");
    else window.localStorage.removeItem(SUPPORT_MODE_STORAGE_KEY);
  } catch {
    // Best effort persistence only.
  }
}

/** Support-only diagnostics flag, toggled with Ctrl+Alt+D and persisted in localStorage. */
export function useSupportMode(): boolean {
  const [enabled, setEnabled] = useState<boolean>(readSupportMode);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (!e.ctrlKey || !e.altKey || e.key.toLowerCase() !== "d") return;
      e.preventDefault();
      setEnabled((prev) => {
        const next = !prev;

        writeSupportMode(next);
        return next;
      });
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return enabled;
}
